module.exports = __webpack_public_path__ + "static/media/convert-step2.abd7ed6a.png";